











































import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'
import _capitalize from 'lodash/capitalize'
import _get from 'lodash/get'

import { User, Auth0UserProfile } from '@/types'
import { AuthState } from '@/store/auth/types'

const namespace: string = 'auth'

@Component({
  components: {},
  methods: {
    _capitalize,
  },
})
export default class UserProfile extends Vue {
  @State(namespace) private authState: AuthState | undefined
  @Getter('getUserInfo', { namespace }) private userInfo: User | undefined
  @Getter('getAuth0UserProfile', { namespace }) private userAuth0Profile:
    | Auth0UserProfile
    | undefined

  private mounted(): void {}

  private destroyed(): void {}

  get roles() {
    return _get(this.userAuth0Profile, ['roles']) || []
  }

  get status() {
    return _get(this.userInfo, ['status'])
  }
}
